module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0041.jpg?v=6e3c8335";